<div class="search-filter">
  <p-inputgroup class="flex-grow-1">
    <p-iconfield class="flex-grow-1">
      <p-inputicon styleClass="pi pi-search" />
      <input
        class="w-100"
        pInputText
        type="text"
        [formControl]="searchControl"
        [maxlength]="50"
        placeholder="Filter by: Name, Property Info, Loan Status or Loan Number"
        #searchControlElement
      />
    </p-iconfield>
    <p-inputgroup-addon>
      <p-button type="button" icon="pi pi-times" severity="danger" (click)="searchControl.setValue('')" />
    </p-inputgroup-addon>
  </p-inputgroup>
</div>
<p-listbox [options]="searchResults">
  <ng-template let-result pTemplate="item">
    <div class="gap-2 listbox-row">
      <div class="d-flex justify-content-between">
        <div>
          <div cmgHighlight [searchTerm]="searchTerm" [text]="result.borrowerFirstName + ' ' + result.borrowerLastName"></div>
          @for (otherBorrower of result.otherBorrowerFullNames; track otherBorrower) {
            <div cmgHighlight [searchTerm]="searchTerm" [text]="otherBorrower"></div>
          }
        </div>
        <div><span class="fw-bold">Status:&nbsp;</span><span cmgHighlight [searchTerm]="searchTerm" [text]="result.loanStatus"></span></div>
      </div>
      <div class="d-flex justify-content-between">
        <div cmgHighlight [searchTerm]="searchTerm" [text]="result.propertyStreet ?? 'TBD'"></div>
        <div><span class="fw-bold">Loan #:&nbsp;</span><span cmgHighlight [searchTerm]="searchTerm" [text]="result.loanNumber"></span></div>
      </div>
      <div class="d-flex">
        <div
          cmgHighlight
          [searchTerm]="searchTerm"
          [text]="result.propertyCity ?? '' + ' ' + result.propertyState ?? '' + ' ' + result.propertyZip ?? ''"
        ></div>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <span class="fw-bold">Modified:&nbsp;</span>
          <span cmgHighlight [searchTerm]="searchTerm" [text]="result.dateModified | date: 'MM/dd/yy h:mm a'"></span>
        </div>
        <button pButton class="view-details-btn p-button-secondary" size="small">
          <a [href]="'/urla2/' + result.loanID" target="_blank"><span class="link fw-semibold">View Details</span></a>
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="empty">
    <div class="gap-2 listbox-row empty-row d-flex justify-content-center">
      <span class="empty-message fw-bold">No results matched filter text</span>
    </div>
  </ng-template>
</p-listbox>
